// src/modules/operaciones/inventarios/hooks/useNegativos.js
import { useState, useEffect, useCallback, useRef } from "react";
import { API_URL, POLL_MS, POLL_MAX_MS, pedirJson } from "../utils/negativosComun";

export default function useNegativos() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [calculando, setCalculando] = useState(true);
  const [error, setError] = useState(null);
  const [totalArticulos, setTotalArticulos] = useState(0);
  const [progreso, setProgreso] = useState({ porcentaje: 0, procesados: 0, total: 0 });

  const pollStartRef = useRef(null);

  const cargar = useCallback(async (signal) => {
    try {
      // 1. Pedimos la lista de negativos
      const data = await pedirJson(`${API_URL}/negativos/lista?limite=3000&estado=todos`, signal);
      
      const listaItems = Array.isArray(data.data) ? data.data : [];
      setItems(listaItems);
      const estaCalculando = Boolean(data.meta?.calculando);
      setCalculando(estaCalculando);
      setError(null);
      
      // 2. Leemos el total exacto que envía el backend en "meta.totalReal"
      if (!estaCalculando && data.meta) {
        if (data.meta.totalReal) {
          setTotalArticulos(data.meta.totalReal);
        } else {
          // Fallback por si el backend envía una versión vieja
          setTotalArticulos(listaItems.length); 
        }
      }
      
      // 3. Si está calculando, consultamos el progreso
      if (estaCalculando) {
        try {
          const prog = await pedirJson(`${API_URL}/negativos/progreso`, signal);
          if (prog.success && prog.data) {
            setProgreso(prog.data);
          }
        } catch (e) {}
      }
      
      return { listo: !estaCalculando };
    } catch (e) {
      if (e.name !== "AbortError") setError(e.message);
      return { listo: true, error: true };
    }
  }, []);

  useEffect(() => {
    const ctrl = new AbortController();
    let timer;

    const ciclo = async () => {
      if (ctrl.signal.aborted) return;
      if (!pollStartRef.current) pollStartRef.current = Date.now();
      setLoading(true);

      const r = await cargar(ctrl.signal);
      if (ctrl.signal.aborted) return;

      if (r.error) {
        setLoading(false);
        return;
      }
      setLoading(!r.listo);

      if (!r.listo) {
        const elapsed = Date.now() - pollStartRef.current;
        if (elapsed < POLL_MAX_MS) {
          timer = setTimeout(ciclo, POLL_MS);
          return;
        }
        setError("El cálculo está tardando más de lo esperado.");
      }
      setLoading(false);
    };

    ciclo();
    return () => {
      ctrl.abort();
      if (timer) clearTimeout(timer);
    };
  }, [cargar]);

  return { items, loading, calculando, error, totalArticulos, progreso };
}